import { Component, Vue } from 'vue-property-decorator';
import authenticator from '@/store/authentication';

@Component
export default class SilentRefreshTokenCallback extends Vue {

    private async created() {
        // This page is called by userManager.signinSilent in addAccessTokenExpiring event.
        await authenticator.signinSilentCallbackAsync();
               //  .catch((reason) => {
               //      console.log('SilentRefreshTokenCallback', reason);
               //  });
    }
}
